import React from "react";

const MAP = [
  { k: ["CONFIRMED", "VERIFIED", "APPROVED", "ACTIVE", "AVAILABLE", "COMPLETED", "sent", "active"], c: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { k: ["CHECKED_IN", "IN_PROGRESS", "STARTING_SOON"], c: "bg-blue-50 text-blue-700 border-blue-200" },
  { k: ["PENDING", "HOLD", "REQUESTED", "pending"], c: "bg-amber-50 text-amber-700 border-amber-200" },
  { k: ["REJECTED", "CANCELLED", "EXPIRED", "BOOKED", "inactive", "failed"], c: "bg-rose-50 text-rose-700 border-rose-200" },
  { k: ["CHECKED_OUT"], c: "bg-slate-100 text-slate-600 border-slate-200" },
];

export function StatusBadge({ status, className = "" }) {
  if (!status) return null;
  const s = String(status);
  let cls = "bg-slate-100 text-slate-600 border-slate-200";
  for (const m of MAP) {
    if (m.k.some((key) => s.toUpperCase().includes(key.toUpperCase()))) { cls = m.c; break; }
  }
  const pulse = s.toUpperCase().includes("PENDING") ? " animate-pulse" : "";
  return (
    <span
      data-testid={`status-badge-${s}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[11px] font-semibold tracking-wide ${cls}${pulse} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {s.replace(/_/g, " ")}
    </span>
  );
}
